import {apiV2Link} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {IRecommendedOffer} from "../types/IRecommendedOffer";

interface IGetRecommendedOffersPayload {
    offerId: number;
    numberOfRooms?: number[] | null;
    excludedOfferIds: number[];
}

interface IGetRecommendedOffersResponse {
    results: IRecommendedOffer[];
}

export const getRecommendedOffersApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getRecommendedOffers: build.query<IGetRecommendedOffersResponse, IGetRecommendedOffersPayload>({
            query: ({offerId, numberOfRooms, excludedOfferIds}) => ({
                url: apiV2Link.offer.similar({offerId}),
                params: {
                    ...(!!numberOfRooms && numberOfRooms.length > 0 && {rooms: numberOfRooms.join(",")}),
                    page_size: 6,
                    exclude_offer: excludedOfferIds,
                    exclude_grouped: 1 // exclude offers from the same group of stages
                }
            }),
            transformErrorResponse: (response) => {
                return getIgnoredNotifyResponse(response, [404]);
            }
        })
    })
});

export const {useGetRecommendedOffersQuery} = getRecommendedOffersApi;
import {apiV2Link} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {IRecommendedOffer} from "../types/IRecommendedOffer";

interface IGetRecommendedOffersPayload {
    offerId: number;
    numberOfRooms?: number[] | null;
    excludedOfferIds: number[];
}

interface IGetRecommendedOffersResponse {
    results: IRecommendedOffer[];
}

export const getRecommendedOffersApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getRecommendedOffers: build.query<IGetRecommendedOffersResponse, IGetRecommendedOffersPayload>({
            query: ({offerId, numberOfRooms, excludedOfferIds}) => ({
                url: apiV2Link.offer.similar({offerId}),
                params: {
                    ...(!!numberOfRooms && numberOfRooms.length > 0 && {rooms: numberOfRooms.join(",")}),
                    page_size: 6,
                    exclude_offer: excludedOfferIds,
                    exclude_grouped: 1 // exclude offers from the same group of stages
                }
            }),
            transformErrorResponse: (response) => {
                return getIgnoredNotifyResponse(response, [404]);
            }
        })
    })
});

export const {useGetRecommendedOffersQuery} = getRecommendedOffersApi;
